module.exports = __webpack_public_path__ + "static/media/telenet_logo.80b96f8d.svg";